import React, { Component } from 'react';
import styled from 'styled-components';
import Helmet from 'react-helmet';
import axios from 'axios';

import LabelledTextInput from '../components/LabelledTextInput';
import Button from '../components/Button';
import MessageSection from '../components/MessageSection';
import Notice from '../components/Notice';
import { MenuItem } from '../components/styled';

import { SearchParams } from '../../lib/utils';

const fields = [
	{ name: 'newPassword', placeHolder: 'NEW PASSWORD', inputWidth: 900, containerWidth: 950 },
	{ name: 'newPasswordConfirm', placeHolder: 'CONFIRM NEW PASSWORD', inputWidth: 900, containerWidth: 950 },
]

export default class PasswordReset extends Component {
	constructor(props) {
		super(props);

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.validateField = this.validateField.bind(this);

		this.state = {
			submitted: false,
		};
	}

	onChange(name) {
		return (e) => {
			e.preventDefault();
			this.setState({ [name]: e.target.value });
		}
	}

	validateField(field, value) {
		if (!value) return false;

		switch(field) {
			case 'newPassword':
				return value.length > 0;
			case 'newPasswordConfirm':
				return value.length > 0;
			default:
				return false;
		}
	}

	onSubmit(e) {
		e.preventDefault();

		const errors = {};
		fields.forEach((field) => {
			if (this.validateField(field.name, this.state[field.name])) {
				delete errors[field.name];
			} else {
				errors[field.name] = true;
			}
		});

		
		if (Object.keys(errors).length > 0) {
			return this.setState({ errorMessage: "Sorry, that password isn't valid." });
		}

		if (this.state.newPassword !== this.state.newPasswordConfirm) {
			return this.setState({ errorMessage: 'Please make sure both passwords match.' });
		}

		const queryParams = this.props.location.search;
		const params = new SearchParams(queryParams);
		const resetKey = params.get('resetKey');
		if (!resetKey) {
			return this.setState({ errorMessage: "Sorry, that reset password key isn't valid." });
		}

		axios.post('/api/account/reset-password', {
			password: this.state.newPassword,
			key: resetKey,
		}).then(({ data }) => {
			console.log('test', data);
			if (!data.success) {
				if (data.error === 'account-doesnt-exist') {
					return this.setState({ errorMessage: "Sorry, that reset password key isn't valid." });
				} else if (data.message === 'You must specify a key value') {
					return this.setState({ submitted: true });
				}

				this.setState({ errorMessage: data.error || data.message || data.errorMessage });
			} else {
				return this.setState({ submitted: true }, () => {
					setTimeout(() => {
						window.location.replace(`/agent-login`);
					}, 2500);
				})
			}
		}).catch((err) => {
			this.setState({ error: err });
		});
	}

	render () {
		return (
			<Container>
				<Helmet
					title="Activate"
					meta={[
						{ charset: 'utf-8' },
						{ name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' },
						{ name: 'description', content: 'Activate' },
					]}
					link={[
						{ href: 'https://fonts.googleapis.com/css?family=Roboto+Slab|Karla', rel: 'stylesheet' },
					]}
				/>
				<HeaderContainer>
					<HeaderSection>
						<LogoContainer>
							<a href="/agent"><Image src="/images/redesign/logo.png" /></a>
						</LogoContainer>
						<div>
							<MenuContainer>
								<MenuItem><a href="/agent/faqs">FAQs</a></MenuItem>
							</MenuContainer>
						</div>
					</HeaderSection>
				</HeaderContainer>
				<div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
					{!this.state.submitted ? (
						<MessageSection
							style={{ marginTop: '50px' }}
							header="Create a new password"
							paragraph1="Please create a new password."
						/>
					) : (
						<MessageSection
							header="Password has been succesfully reset"
							paragraph1="You will be redirected the login page shortly."
						/>
					)}
					{this.state.errorMessage ? (
						<div style={{ display: 'flex', justifyContent: 'center', }}>
							<Notice
								color="red"
								text={this.state.errorMessage}
								width="750"
							/>
						</div>
					) : null}
					{!this.state.submitted ? (
						<CenteredContainer>
							<InputContainer>
								{fields.map((field, key) => (
									<Column key={key} style={field.containerWidth ? { width: field.containerWidth } : {}}>
										<LabelledTextInput
											placeHolder={field.placeHolder}
											name={field.name}
											type="password"
											value={this.state[field.name]}
											onChange={this.onChange(field.name)}
											style={field.inputWidth ? { width: field.inputWidth } : {}}
										/>
									</Column>
								))}
							</InputContainer>
						</CenteredContainer>
					): null}
					{!this.state.submitted ? (
						<Button
							text="SUBMIT"
							onSubmit={this.onSubmit} 
						/>
					) : null}
				</div>
			</Container>
		);
	}
};

const InputContainer = styled.div`
	display: flex;
	width: 946px;
	justify-content: space-between;
	margin: 24px;
	flex-wrap: wrap;
`;

const CenteredContainer = styled.div`
	display: flex;
	justify-content: center;
`;

const HeaderContainer = styled.div`
	display: flex;
	justify-content: center;
	border-bottom: 1px solid #dadada;
`;

const HeaderSection = styled.div`
	display: flex;
	width: 946px;
	justify-content: space-between;
	align-items: center;
	height: 50px;
`;

const LogoContainer = styled.div`
	max-width: 120px;
`;

const MenuContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	
`;

const Column = styled.div`
	width: 465px;
	margin-bottom: 20px;
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

const Image = styled.img`
	display: block;
	height: auto;
	width: 100%;
`;



// WEBPACK FOOTER //
// ./client/redesign/web/PasswordReset/index.js